module.exports = "<div [ngClass]=\"currentClasses\">\n</div>\n"